module.exports = __webpack_public_path__ + "img/trtl.1671411c.svg";